module.exports = __webpack_public_path__ + "static/media/bieffe.2101bee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/lite/bieffe.png
// module id = 829
// module chunks = 20